import { useTranslation } from 'react-i18next';

/**
 * The `ui` namespace: the words the primitives say for themselves — a retry
 * button, a filter's Apply, a scanner's permission error.
 *
 * This library holds no domain copy. Anything a caller might word differently
 * is a prop instead (`UIConfirmationModal`'s `cancelText`, every `label`); the
 * keys here are the ones intrinsic to the component.
 */
export const useUITranslation = () => useTranslation('ui');
